function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { resetComponent, resetIcon, textEllipsis } from '../../style';
import { genCompactItemStyle } from '../../style/compact-item';
import { genComponentStyleHook, mergeToken } from '../../theme/internal';
import genDropdownStyle from './dropdown';
import genMultipleStyle from './multiple';
import genSingleStyle from './single'; // ============================= Selector =============================

var genSelectorStyle = function genSelectorStyle(token) {
  var _$concat, _ref2;

  var componentCls = token.componentCls;
  return _ref2 = {
    position: 'relative',
    backgroundColor: token.colorBgContainer,
    border: "".concat(token.lineWidth, "px ").concat(token.lineType, " ").concat(token.colorBorder),
    transition: "all ".concat(token.motionDurationMid, " ").concat(token.motionEaseInOut),
    input: {
      cursor: 'pointer'
    }
  }, _defineProperty(_ref2, "".concat(componentCls, "-show-search&"), {
    cursor: 'text',
    input: {
      cursor: 'auto',
      color: 'inherit'
    }
  }), _defineProperty(_ref2, "".concat(componentCls, "-disabled&"), (_$concat = {
    color: token.colorTextDisabled,
    background: token.colorBgContainerDisabled,
    cursor: 'not-allowed'
  }, _defineProperty(_$concat, "".concat(componentCls, "-multiple&"), {
    background: token.colorBgContainerDisabled
  }), _defineProperty(_$concat, "input", {
    cursor: 'not-allowed'
  }), _$concat)), _ref2;
}; // ============================== Status ==============================


var genStatusStyle = function genStatusStyle(rootSelectCls, token) {
  var _Object$assign;

  var overwriteDefaultBorder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var componentCls = token.componentCls,
      borderHoverColor = token.borderHoverColor,
      outlineColor = token.outlineColor,
      antCls = token.antCls;
  var overwriteStyle = overwriteDefaultBorder ? _defineProperty({}, "".concat(componentCls, "-selector"), {
    borderColor: borderHoverColor
  }) : {};
  return _defineProperty({}, rootSelectCls, _defineProperty({}, "&:not(".concat(componentCls, "-disabled):not(").concat(componentCls, "-customize-input):not(").concat(antCls, "-pagination-size-changer)"), Object.assign(Object.assign({}, overwriteStyle), (_Object$assign = {}, _defineProperty(_Object$assign, "".concat(componentCls, "-focused& ").concat(componentCls, "-selector"), {
    borderColor: borderHoverColor,
    boxShadow: "0 0 0 ".concat(token.controlOutlineWidth, "px ").concat(outlineColor),
    outline: 0
  }), _defineProperty(_Object$assign, "&:hover ".concat(componentCls, "-selector"), {
    borderColor: borderHoverColor
  }), _Object$assign))));
}; // ============================== Styles ==============================
// /* Reset search input style */


var getSearchInputWithoutBorderStyle = function getSearchInputWithoutBorderStyle(token) {
  var componentCls = token.componentCls;
  return _defineProperty({}, "".concat(componentCls, "-selection-search-input"), {
    margin: 0,
    padding: 0,
    background: 'transparent',
    border: 'none',
    outline: 'none',
    appearance: 'none',
    '&::-webkit-search-cancel-button': {
      display: 'none',
      '-webkit-appearance': 'none'
    }
  });
}; // =============================== Base ===============================


var genBaseStyle = function genBaseStyle(token) {
  var _Object$assign2, _Object$assign3, _ref6;

  var componentCls = token.componentCls,
      inputPaddingHorizontalBase = token.inputPaddingHorizontalBase,
      iconCls = token.iconCls;
  return _ref6 = {}, _defineProperty(_ref6, componentCls, Object.assign(Object.assign({}, resetComponent(token)), (_Object$assign3 = {
    position: 'relative',
    display: 'inline-block',
    cursor: 'pointer'
  }, _defineProperty(_Object$assign3, "&:not(".concat(componentCls, "-customize-input) ").concat(componentCls, "-selector"), Object.assign(Object.assign({}, genSelectorStyle(token)), getSearchInputWithoutBorderStyle(token))), _defineProperty(_Object$assign3, "".concat(componentCls, "-selection-item"), Object.assign({
    flex: 1,
    fontWeight: 'normal'
  }, textEllipsis)), _defineProperty(_Object$assign3, "".concat(componentCls, "-selection-placeholder"), Object.assign(Object.assign({}, textEllipsis), {
    flex: 1,
    color: token.colorTextPlaceholder,
    pointerEvents: 'none'
  })), _defineProperty(_Object$assign3, "".concat(componentCls, "-arrow"), Object.assign(Object.assign({}, resetIcon()), (_Object$assign2 = {
    position: 'absolute',
    top: '50%',
    insetInlineStart: 'auto',
    insetInlineEnd: inputPaddingHorizontalBase,
    height: token.fontSizeIcon,
    marginTop: -token.fontSizeIcon / 2,
    color: token.colorTextQuaternary,
    fontSize: token.fontSizeIcon,
    lineHeight: 1,
    textAlign: 'center',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center'
  }, _defineProperty(_Object$assign2, iconCls, _defineProperty({
    verticalAlign: 'top',
    transition: "transform ".concat(token.motionDurationSlow),
    '> svg': {
      verticalAlign: 'top'
    }
  }, "&:not(".concat(componentCls, "-suffix)"), {
    pointerEvents: 'auto'
  })), _defineProperty(_Object$assign2, "".concat(componentCls, "-disabled &"), {
    cursor: 'not-allowed'
  }), _defineProperty(_Object$assign2, '> *:not(:last-child)', {
    marginInlineEnd: 8 // FIXME: magic

  }), _Object$assign2))), _defineProperty(_Object$assign3, "".concat(componentCls, "-clear"), {
    position: 'absolute',
    top: '50%',
    insetInlineStart: 'auto',
    insetInlineEnd: inputPaddingHorizontalBase,
    zIndex: 1,
    display: 'inline-block',
    width: token.fontSizeIcon,
    height: token.fontSizeIcon,
    marginTop: -token.fontSizeIcon / 2,
    color: token.colorTextQuaternary,
    fontSize: token.fontSizeIcon,
    fontStyle: 'normal',
    lineHeight: 1,
    textAlign: 'center',
    textTransform: 'none',
    background: token.colorBgContainer,
    cursor: 'pointer',
    opacity: 0,
    transition: "color ".concat(token.motionDurationMid, " ease, opacity ").concat(token.motionDurationSlow, " ease"),
    textRendering: 'auto',
    '&:before': {
      display: 'block'
    },
    '&:hover': {
      color: token.colorTextTertiary
    }
  }), _defineProperty(_Object$assign3, '&:hover', _defineProperty({}, "".concat(componentCls, "-clear"), {
    opacity: 1
  })), _Object$assign3))), _defineProperty(_ref6, "".concat(componentCls, "-has-feedback"), _defineProperty({}, "".concat(componentCls, "-clear"), {
    insetInlineEnd: inputPaddingHorizontalBase + token.fontSize + token.paddingXS
  })), _ref6;
}; // ============================== Styles ==============================


var genSelectStyle = function genSelectStyle(token) {
  var _componentCls;

  var componentCls = token.componentCls;
  return [_defineProperty({}, componentCls, (_componentCls = {}, _defineProperty(_componentCls, "&-borderless ".concat(componentCls, "-selector"), {
    backgroundColor: "transparent !important",
    borderColor: "transparent !important",
    boxShadow: "none !important"
  }), _defineProperty(_componentCls, "&".concat(componentCls, "-in-form-item"), {
    width: '100%'
  }), _componentCls)), // =====================================================
  // ==                       LTR                       ==
  // =====================================================
  // Base
  genBaseStyle(token), // Single
  genSingleStyle(token), // Multiple
  genMultipleStyle(token), // Dropdown
  genDropdownStyle(token), // =====================================================
  // ==                       RTL                       ==
  // =====================================================
  _defineProperty({}, "".concat(componentCls, "-rtl"), {
    direction: 'rtl'
  }), // =====================================================
  // ==                     Status                      ==
  // =====================================================
  genStatusStyle(componentCls, mergeToken(token, {
    borderHoverColor: token.colorPrimaryHover,
    outlineColor: token.controlOutline
  })), genStatusStyle("".concat(componentCls, "-status-error"), mergeToken(token, {
    borderHoverColor: token.colorErrorHover,
    outlineColor: token.colorErrorOutline
  }), true), genStatusStyle("".concat(componentCls, "-status-warning"), mergeToken(token, {
    borderHoverColor: token.colorWarningHover,
    outlineColor: token.colorWarningOutline
  }), true), // =====================================================
  // ==             Space Compact                       ==
  // =====================================================
  genCompactItemStyle(token, {
    borderElCls: "".concat(componentCls, "-selector"),
    focusElCls: "".concat(componentCls, "-focused")
  })];
}; // ============================== Export ==============================


export default genComponentStyleHook('Select', function (token, _ref) {
  var rootPrefixCls = _ref.rootPrefixCls;
  var selectToken = mergeToken(token, {
    rootPrefixCls: rootPrefixCls,
    inputPaddingHorizontalBase: token.paddingSM - 1
  });
  return [genSelectStyle(selectToken)];
}, function (token) {
  return {
    zIndexPopup: token.zIndexPopupBase + 50
  };
});